<!-- loader.component.html -->
<div [id]="loaderId" [ngClass]="spinnerClass" style="display: none">
  <div class="loader"></div>
</div>
